import { render } from "./BankDeposit.vue?vue&type=template&id=52adb39d"
import script from "./BankDeposit.vue?vue&type=script&lang=js"
export * from "./BankDeposit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__